import { canUseWebP } from 'fe-common'
import { onMounted, ref } from '@nuxtjs/composition-api'

export default function useWebp() {
  const isSupportWebp = ref(false)

  onMounted(() => {
    isSupportWebp.value = canUseWebP()
    if (isSupportWebp.value) {
      document.body.classList.add('webp')
    } else {
      document.body.classList.add('no-webp')
    }
  })

  return {
    isSupportWebp
  }
}
